/**
 * @module utils/storeHelpers
 */

export const asyncLoadStore = () =>
	new Promise((resolve, reject) =>
		import('store')
			.then(({ default: store }) => resolve(store))
			.catch(err => {
				console.error('[storeHelpers] asyncLoadStore: \nerr = ', err);
				return reject(err);
			})
	);

export const asyncDispatch = action =>
	action
		? asyncLoadStore().then(store => store.dispatch(action))
		: Promise.reject(Error('Invalid action'));

export const getStateFromStore = store => {
	const state = store.getState();
	if (!state) throw new Error('Failed to get store state');
	return state;
};

export const asyncGetStoreState = () =>
	asyncLoadStore()
		.then(getStateFromStore)
		.catch(err => {
			console.error('[storeHelpers] asyncGetStoreState: \nerr = ', err);
			throw err;
		});

export const asyncGetReducerState = field =>
	asyncGetStoreState().then(state => state[field]);
